import React, { memo, useEffect, useRef, useState, forwardRef } from "react";
import { AnimatePresence, motion } from "framer-motion/dist/framer-motion";
import EditNote from "./EditNote";
import Modal from "react-bootstrap/Modal";
import * as commonData from "../../../Common";
import { connect, useDispatch } from "react-redux";
import { UploadImage } from "../../../Actions/imageUpload";
import { clearAllAttachment } from "../../../Actions/clearAllAttachment";
import { clearFileArray } from "../../../Actions/imageUpload/UploadImage";
import ImagePreview from "../ImagePreview";
const ModalUi = forwardRef((props, refs) => {
  const dispatch = useDispatch();
  const refsEdit = useRef();
  const [showm, setShow] = useState(props.show);
  const [note, setNote] = useState({});
  const [editContent, setEditContent] = useState("");
  const [error, setError] = useState("");
  const [noteImages, setImages] = useState({});
  const [singleText, setSingleText] = useState("");
  const [editNoteContent, setEditNoteContent] = useState({});
  const [removeAttachment, setRemoveAttachment] = useState([]);

  useEffect(() => {
    setShow(props.show);
    setNote(props.editNote);
    setImages({});
  }, [props.show]);
  useEffect(() => {
    setImages(props.uploadAtt);
  }, [props.uploadAtt]);
  useEffect(() => {
    setError(error);
  }, [error]);
  useEffect(() => {
    setEditNoteContent(props.editNote);
  }, [props.editNote]);

  const hideUiModal = () => {
    props.hideUiModal();
    dispatch(clearAllAttachment());
    dispatch(clearFileArray());
  };

  const deleteEditAttachment = async (id) => {
    const ids = [...removeAttachment, id];
    setRemoveAttachment((state) => {
      return [...state, id];
    });
    const apiUrl = commonData.commonData().apiUrl;
    const newcontent = { ...editNoteContent };
    const attachment = {
      ...delete newcontent.attachment[id],
      ...newcontent.attachment,
    };
    newcontent.attachment = attachment;
    setEditNoteContent(newcontent);
  };

  const getImages = (images) => {
    const data = commonData.getCommonData();
    let inputs = {
      images,
      app_token: data.app_token,
      product_key: process.env.REACT_APP_PRODUCT_KEY,
      attribute_set_key: props.attribute_set_key,
      customer_tattle_uuid: props.customer_tattle_uuid,
      edit: true,
      key: "edit",
    };
    dispatch(UploadImage(inputs));
    setImages(props.uploadAtt);
    props.setImages(images);
  };

  const getRawData = async (html, json, mention) => {
    props.updateContent(html, json, mention);
  };

  const getValidData = (html) => {
    setSingleText(html);
  };

  const deleteFromLocalImage = (index) => {
    const deleImages = { ...delete noteImages[index], ...noteImages };
    setImages(deleImages);
  };
  const onChangeValidation = (test) => {
    if (test.length > 0) {
      setError(false);
    } else {
      setError(true);
    }
  };
  const formSubmitHandler = (evt) => {
    evt.preventDefault();
    let newImagesTransforms = {
      ...noteImages,
      ...editNoteContent.attachment,
    };
    if (singleText.trim() != "") {
      props.submitNote(
        editContent,
        props?.editNote._id,
        props?.editNote.custom_note_uuid,
        removeAttachment,
        newImagesTransforms
      );
      setRemoveAttachment([]);
      setSingleText("");
      setError(false);
    } else {
      refsEdit?.current?.focus();
      setError(true);
    }
    dispatch(clearFileArray());
  };

  return (
    <Modal show={props.show} onHide={hideUiModal} centered>
      <Modal.Header closeButton>
        <Modal.Title>
          Edit note of : {props?.editNote?.user_details?.name}
        </Modal.Title>
      </Modal.Header>
      <form onSubmit={formSubmitHandler}>
        <Modal.Body className="pt-0">
          <div className="row">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
              {error ? (
                <div className="invalid-feedback" style={{ display: "block" }}>
                  Note shouldn't be blank
                </div>
              ) : null}
              <div className="inputBox-group">
                <EditNote
                  value={props.editNote.note_content_json || ""}
                  getRawDataOnchange={getRawData}
                  onBlurClose={() => {}}
                  getValidData={getValidData}
                  onChangeValidation={onChangeValidation}
                  users={props.users}
                  refs={refsEdit}
                  editNote={true}
                  getImages={getImages}
                />
                <div className="invalid-feedback">{props.error}</div>
              </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
              <div className="custom_image">
                <div class="afterupload-image">
                  {noteImages && Object.keys(noteImages).length > 0
                    ? Object.keys(noteImages).map((item, index) => {
                        return (
                          <div class="img-box edit_note">
                            <ImagePreview
                              ext={noteImages[item]?.file_name.split(".").pop()}
                              headImage={noteImages[item]?.file_url}
                            />
                            <figure title={noteImages[item]?.file_name}>
                              {noteImages[item]?.file_name?.slice(0, 7) +
                                "." +
                                noteImages[item]?.file_name?.split(".").pop()}
                            </figure>
                            <div class="delete">
                              <svg
                                width="11"
                                height="10"
                                viewBox="0 0 11 10"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                onClick={() => deleteFromLocalImage(item)}
                              >
                                <title>Remove</title>
                                <path
                                  d="M8.21973 2.5L3.21973 7.5"
                                  stroke="#737373"
                                  stroke-width="1.33"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                ></path>
                                <path
                                  d="M3.21973 2.5L8.21973 7.5"
                                  stroke="#737373"
                                  stroke-width="1.33"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                ></path>
                              </svg>
                            </div>
                          </div>
                        );
                      })
                    : null}
                  {editNoteContent.hasOwnProperty("attachment") &&
                    Object?.keys(editNoteContent?.attachment).map((it) => {
                      return (
                        <div class="img-box edit_note">
                          <ImagePreview
                            ext={editNoteContent?.attachment[it].file_name
                              .split(".")
                              .pop()}
                            headImage={editNoteContent?.attachment[it]}
                          />

                          <div class="delete">
                            <svg
                              width="11"
                              height="10"
                              viewBox="0 0 11 10"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                              onClick={() =>
                                deleteEditAttachment(
                                  editNoteContent?.attachment[it].file_uuid
                                )
                              }
                            >
                              <title>Remove</title>
                              <path
                                d="M8.21973 2.5L3.21973 7.5"
                                stroke="#737373"
                                stroke-width="1.33"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              ></path>
                              <path
                                d="M3.21973 2.5L8.21973 7.5"
                                stroke="#737373"
                                stroke-width="1.33"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              ></path>
                            </svg>
                          </div>
                        </div>
                      );
                    })}
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="cancl-cls"
            data-bs-dismiss="modal"
            onClick={hideUiModal}
          >
            Cancel
          </button>
          <button type="submit" className="submit-cls">
            {props.isUpdate ? "Updating..." : "Update"}
          </button>
        </Modal.Footer>
      </form>
    </Modal>
  );
});
const mapStateToProps = (state) => {
  return {
    uploadAtt: state.boardAttribute.allAttachImage_edit?.["edit"],
    isUploadDone: state.boardAttribute?.isImageUpload,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    clearAllAttachment: () => {
      return dispatch(action.clearAllAttachment());
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(memo(ModalUi));
